<script>
import Dialog from "primevue/dialog";

export default {
    data() {
        return {
            visible: false
        }
    },
    props: {
        url: {
            type: String,
            required: true
        }
    },
    methods: {
        onOpen() {
            this.visible = true;
        },
    },
    components: {
        Dialog,
    }
}
</script>
<template>
    <div>
        <a href @click.prevent="onOpen" :title="$t('lang.report.video')" style="margin-left: 5px;" class="bluebutton pull-right">{{ $t('lang.report.video') }}</a>
        <Dialog
            v-model:visible="visible"
            :modal="true"
            :showHeader="false"
            :dismissableMask="true"
            contentClass="youtube-dialog-content"
        >
            <iframe
                loading="lazy"
                :src="url"
                width="560" height="315"
                allowfullscreen
            ></iframe>
        </Dialog>
    </div>
</template>

<style>
.youtube-dialog-content {
    padding: 0 !important;
    width: 560px;
    height: 315px;
    max-width: 100vw;
    max-height: 100vh;
}
.youtube-dialog-content iframe {
    height: 100%;
    width: 100%;
    border: 0;
}
</style>
